import { useCallback } from 'react';

export type UseOpenSubscriptionManagementOptions = {
  data: string | undefined;
  isFetching: boolean;
  refetch: () => Promise<string | undefined>;
  onTrigger?: () => void;
};

export const useOpenSubscriptionManagement = ({
  data,
  isFetching,
  refetch,
  onTrigger,
}: UseOpenSubscriptionManagementOptions) => {
  const fetch = useCallback(async () => {
    onTrigger?.();
    return refetch();
  }, [refetch, onTrigger]);

  return { fetch, url: data ?? null, isLoading: isFetching };
};
